import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './LeaderTeam.css';
import PageTitle from '../Layout/components/PageTitle';
import { Dialog } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import { clone, deduplicationObjArr } from '../../common/utils';
import instance from '../../request/http';
import Toast from '../Layout/components/Toast';
import TeamInfo from './components/TeamInfo';
import DeptInfo from './components/DeptInfo'
import FoldTable from '../Components/FoldTable';
import { ADD, EDIT, VIEW } from '../../common/common';
import userDao from '../../request/userDao';

class LeaderTeam extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openDept: false,
            openTeam: false,
            dialogState: ADD,
            dialogTitle: "",
            currentObj: null,
            deptData: [],
            officeData: [],

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleDeptView = this.handleDeptView.bind(this);
        this.handleTeamView = this.handleTeamView.bind(this);
        this.handleTeamEdit = this.handleTeamEdit.bind(this);

        this.handleEditTeam = this.handleEditTeam.bind(this);
        this.handleTeamCancel = this.handleTeamCancel.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            openDept,
            openTeam,
            dialogTitle,
            dialogState,
            currentObj,
            deptData,
            officeData,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <PageTitle title="TEAM" subtitle="MANAGEMENT"></PageTitle>
                <FoldTable
                    deptsData={deptData}
                    handleDeptView={this.handleDeptView}
                    handleTeamView={this.handleTeamView}
                    handleTeamEdit={this.handleTeamEdit}
                />
                <Dialog maxWidth={false} open={openDept}>
                    <DeptInfo
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={currentObj}
                        state={dialogState}
                        officeData={officeData}
                    ></DeptInfo>
                </Dialog>
                <Dialog maxWidth={false} open={openTeam}>
                    <TeamInfo
                        handleCreate={this.handleEditTeam}
                        handleCancel={this.handleTeamCancel}
                        title={dialogTitle}
                        data={currentObj}
                        state={dialogState}
                    ></TeamInfo>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        this.getAllDepts((allDepts) => {
            userDao.getUserInfo((userData) => {
                console.log(userData)
                const userTeams = this.extMyDeptOrTeam(userData.roles, "team");
                const userDepts = this.extractDepts(userTeams);
                this.mergeTeams(allDepts, userDepts, userTeams);
            });
        });
    }
    extMyDeptOrTeam(rolesObj, type) {
        let teamArr = [];
        for (const obj of rolesObj) {
            const teamObj = obj.team;
            const roleObj = obj.role;
            let newObj = {};
            if (teamObj && type === "team") {
                newObj = teamObj;
                newObj.role = roleObj;
                teamArr.push(newObj);
            }
        }
        return teamArr;
    }
    extractDepts(userTeams) {
        let userDepts = [];
        if (userTeams) {
            for (const obj of userTeams) {
                let newObj = {};
                newObj.dept = obj.dept;
                newObj.role = obj.role;
                userDepts.push(newObj);
            }
            // const newUserDepts = deduplicationObjArr(userDepts, "dept", "id");
            return userDepts;
        } else {
            return [];
        }
    }
    mergeTeams(allDepts, userDepts, userTeams) {
        let deptData = [];
        for (const userObj of userDepts) {
            for (const allObj of allDepts) {
                if (userObj.dept.id === allObj.id) {
                    let newObj = clone(allObj);
                    newObj.expanded = false;
                    newObj.role = userObj.role;
                    deptData.push(newObj);
                }
            }
        }
        //过滤该账号所在的dept下不属于该账号的team
        const filterDepts = this.filterOtherTeam(deptData, userTeams);
        const officeData = deduplicationObjArr(allDepts, "office");
        this.setState(() => ({
            deptData: filterDepts,
            officeData
        }));
    }
    filterOtherTeam(deptData, userTeams) {
        const myDept = this.formatUserTeam(deptData, userTeams);
        let newDept = [];
        for (const deptObj of deptData) {
            let newObj = clone(deptObj);
            newObj.teams = [];
            for (const myDeptObj of myDept) {
                if (deptObj.id === myDeptObj.id) {
                    let myDeptTeams = myDeptObj.teams;
                    let deptTeams = deptObj.teams;
                    for (const myDeptTeamObj of myDeptTeams) {
                        for (const deptTeamObj of deptTeams) {
                            if (myDeptTeamObj.id === deptTeamObj.id) {
                                let newTeamObj = clone(deptTeamObj);
                                newTeamObj.role = myDeptTeamObj.role;
                                newObj.teams.push(newTeamObj);
                            }
                        }
                    }
                }
            }
            newDept.push(newObj);
        }
        const filterDepts = deduplicationObjArr(newDept, "id");
        return filterDepts;
    }
    formatUserTeam(deptData, userTeams) {
        let newArr = [];
        for (const deptObj of deptData) {
            let newObj = {};
            newObj.id = deptObj.id;
            newObj.teams = [];
            for (const myDeptObj of userTeams) {
                if (deptObj.id === myDeptObj.dept.id) {
                    let obj = {};
                    obj.id = myDeptObj.id;
                    newObj.teams.push(myDeptObj)
                }
            }
            newArr.push(newObj);
        }
        const myDept = deduplicationObjArr(newArr, "id");
        return myDept;
    }
    handleDeptView(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDeptDialog(obj.name + " INFO", VIEW);
    }
    handleTeamView(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openTeamDialog(obj.name + " TEAM INFO", VIEW);
    }
    handleTeamEdit(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openTeamDialog("EDIT " + obj.name + " TEAM INFO", EDIT);
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    handleTeamCancel() {
        this.initData();
        this.closeDialog();
    }
    handleEditTeam(obj, members) {
        const { dialogState, currentObj } = this.state;
        if (dialogState === EDIT) {
            let team_id = currentObj.id;
            let params = {};
            if (currentObj.name === obj.name) {
                params = {
                    description: obj.description,
                }
            } else {
                params = {
                    name: obj.name,
                    description: obj.description,
                }
            }
            this.updateTeam(team_id, params);
        }
    }
    closeDialog() {
        this.setState(() => ({
            openDept: false,
            openTeam: false,
            currentObj: null,
        }));
    }
    openDeptDialog(title, state) {
        this.setState(() => ({
            openDept: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    openTeamDialog(title, state) {
        this.setState(() => ({
            openTeam: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    //----------------request-------------------------------
    getAllDepts(callback) {
        let params = {
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + 'common/departments', { params }).then((res) => {
            let depts = res.data.data;
            callback(depts);
        })
    }
    getMember(callback) {
        instance.get(BASE_URL + 'team/members').then((res) => {
            const members = res.data.data;
            callback(members)
        })
    }
    //[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    addMember(members, callback) {
        const params = {
            members
        }
        instance.post(BASE_URL + 'team/members', params).then((res) => {
            this.showToast("Added successfully", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    //[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    delMember(members, callback) {
        const params = {
            members
        }
        instance.delete(BASE_URL + 'team/members', { data: params }).then((res) => {
            this.showToast("Successfully deleted", "success");
            this.getTeams();
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateTeam(params) {
        instance.put(BASE_URL + "team/members", params).then((res) => {
            console.log("editTeam", res);
            this.initData();
            this.showToast("Successfully modified", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(LeaderTeam);